import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viAddressBook, viSpinnerThird, viTrashCan } from "@sippy-platform/valkyrie";

import { Card, IconButton, List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function PhonebookItem({ phonebook, dispatch, ...props }) {
  const [pending, setPending] = useState(false);

  const handleRemovePhonebook = () => {
    setPending(true);

    Promise.resolve(Api.deleteUserPhonebook(props.user, phonebook))
      .then(() => dispatch({ type: "removePhonebook", phonebook }))
      .finally(() => setPending(false));
  };

  return (
    <Card variant="outlined">
      <List>
        <ListItem
          secondaryAction={
            <IconButton
              color="inherit"
              onClick={() => handleRemovePhonebook()}
              aria-label="Delete this phonebook"
              disabled={pending}
            >
              <Valkyrie icon={pending ? viSpinnerThird : viTrashCan} spin={pending} />
            </IconButton>
          }
        >
          <ListItemAvatar>
            <Avatar text={phonebook.name} icon={viAddressBook} px={32} />
          </ListItemAvatar>
          <ListItemText primary={phonebook.name} />
        </ListItem>
      </List>
    </Card>
  );
}

PhonebookItem.propTypes = {
  user: PropTypes.object,
  phonebook: PropTypes.object,
  dispatch: PropTypes.func,
};

export default PhonebookItem;
